import { createBaseAction } from '@essent/common';
import type { InnogyComponentRendering } from '@core/jss-models';

export const enum RetentionOfferTypes {
  SET_SELECTED = '[Retention] Set selected offer',
  SUBMIT = '[Retention] Submit retention offer',
  CHOOSE = '[Retention] Choose retention offer',
  CHANGE_CALCULATION = '[Retention] Change calculation',
  TRACK_PRODUCT_IMPRESSION = '[Retention] Track product impression',
  TRACK_ALL_PRODUCTS_IMPRESSION = '[Retention] Track all products impression',
}

export const setSelectedOfferAction = createBaseAction<{
  campaignId: string;
  duration: string;
  rendering: InnogyComponentRendering;
}>(RetentionOfferTypes.SET_SELECTED);

export const submitRetentionProposition = createBaseAction<string>(
  RetentionOfferTypes.SUBMIT
);

export const chooseRetentionProposition = createBaseAction<{
  rendering: InnogyComponentRendering;
  orderPage: string;
}>(RetentionOfferTypes.CHOOSE);

export const changeOfferCalculation =
  createBaseAction<InnogyComponentRendering>(
    RetentionOfferTypes.CHANGE_CALCULATION
  );

export const trackProductImpression = createBaseAction<{
  rendering: InnogyComponentRendering;
}>(RetentionOfferTypes.TRACK_PRODUCT_IMPRESSION);

export const trackAllProductsImpression = createBaseAction<{
  rendering: InnogyComponentRendering;
}>(RetentionOfferTypes.TRACK_ALL_PRODUCTS_IMPRESSION);
